import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchData } from '../../../services/api';
import { ZBUT_MODULE_ID } from '../../../services/zbut';
import { logout } from '../user';

// Дневният статус по задължителния модул "ЗБУТ".
export const fetchZbutStatus = createAsyncThunk(
  'zbut/fetchStatus',
  async () => {
    const response = await fetchData('/zbut/status');
    if (response.status !== 201) throw new Error(response.data.message);
    return response.data.data;
  }
);

const initialState = {
  module_id: ZBUT_MODULE_ID,
  test_id: null,
  required: false,
  submitted_today: false,
  locked: false,
  checked: false,
};

const zbutSlice = createSlice({
  name: 'zbut',
  initialState,
  reducers: {},
  // Състоянието се променя през draft-а (никога нов обект), за да остане
  // референцията същата, когато стойностите не се променят - иначе всеки
  // dispatch преизчислява компонентите, които следят този slice.
  extraReducers: (builder) => {
    builder
      .addCase(fetchZbutStatus.fulfilled, (state, action) => {
        Object.assign(state, action.payload);
        state.checked = true;
      })
      .addCase(fetchZbutStatus.rejected, (state) => {
        // При грешка не заключваме приложението.
        state.locked = false;
        state.checked = true;
      })
      .addCase(logout, (state) => {
        Object.assign(state, initialState);
      });
  }
});

export default zbutSlice.reducer;
